import { env } from "@/config/env";
import { PlatformCompat } from "@huyafed/huya-kiwi";

export async function getUserId() {
  const res = await PlatformCompat.getUserId();
  env.uid = String(res.lUid);
  return res;
}
